<template>
	<div>
		<router-view v-show="$route.matched.length==3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length==2">
			<div class="main-page-content">
				<el-row>
					<el-col class="table-header">
						<div class="table-heade-left">
							<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
								<el-form-item label="状态">
									<el-select v-model="searchCondition.status" @change="selectClick"
										class="select-wrapper">
										<el-option label="全部审核状态" value=""></el-option>
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<!-- <el-form-item label="创建人">
									<el-select v-model="searchCondition.create_uid" filterable placeholder="请选择" clearable>
									<el-option
									v-for="item in createNameList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
									</el-select>
								</el-form-item> -->
								<el-form-item label="创建人">
									<el-input v-model="searchCondition.create_name" placeholder="输入创建人" clearable></el-input>
								</el-form-item>
								<el-form-item label="公司名字">
									<el-input v-model="searchCondition.name" placeholder="输入公司" clearable></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="searchButton">查询</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="end">
					<div class="table-right">
						<MonthPicker @MonthSearch="MonthSearch" />
						<el-select v-model="exportType" placeholder="请选择导出类型" class="select-box" size="medium">
							<el-option v-for="item in exportOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-button :loading="downloadLoading" style="margin:0 10px 15px 20px;" size="medium"
							icon="el-icon-document" @click="handleDownload">
							导出
						</el-button>
						<el-button type="primary" @click="createCompany"
							v-if="userPermissions.indexOf('merchant_creat') != -1">创建公司</el-button>
					</div>
				</el-row>
				<TreeTable :data="list" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"
					@switchPaging="switchPaging" ref="treeTable" highlight-current-row>
					<el-table-column
            show-overflow-tooltip
            align="center"
            label="驳回原因"
          >
            <template slot-scope="scope">
              <el-button
                @click="showReason(scope.row)"
                v-if="scope.row.review_remark"
                type="text"
                >点击查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="80" align="center" label="状态">
						<template slot-scope="scope">
							<div :class="scope.row.alias_status == '待审核' ? 'add-color' : ''">
								{{ scope.row.alias_status }}
							</div>
						</template>
					</el-table-column>
					<el-table-column width="250" align="center" label="操作">
						<template slot-scope="scope">
							<el-button size="mini" icon="iconfont" @click="addButton(scope.row.id)"
								v-if="userPermissions.indexOf('merchant_creat') != -1">添加子公司</el-button>
							<el-button size="mini" type="primary" @click="editButton(scope.row.id)"
								v-if="userPermissions.indexOf('merchant_edit') != -1">编辑</el-button>
							<el-popover v-if="userPermissions.indexOf('merchant_delete') != -1"
								:ref="'el-popover-'+scope.$index" placement="top" width="150">
								<p>确定要删除记录吗？</p>
								<div style="text-align: right; margin: 0;">
									<el-button type="text" size="mini"
										@click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
									<el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定
									</el-button>
								</div>
								<el-button slot="reference" type="danger" size="mini">删除</el-button>
							</el-popover>
							<el-button size="mini" type="text" @click="toExamine(scope.row.id)"
								v-if="userPermissions.indexOf('company_audit') != -1&&scope.row.status==0">审核
							</el-button>
						</template>
					</el-table-column>
				</TreeTable>
			</div>
		</PageHeaderLayout>
		<ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm"
			@dialogClose="examineDialogClose">
			<template slot="content">
				<el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'">
					<el-form-item>
						<el-radio-group v-model="examineRuleForm.status" @change="selectRadio">
							<el-radio label="1">通过</el-radio>
							<el-radio label="2">拒绝</el-radio>
							<!-- <el-radio label="3">禁用</el-radio> -->
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="examineRuleForm.status == 2">
						<!-- <el-input type="textarea" :rows="4" v-model="examineRuleForm.check_remark"
							placeholder="请输入拒绝原因"></el-input> -->
					<!-- <ApeEditor
					:init-html="formData.details"
					:editorHeight="360"
					@handleTinymceInput="handleTinymceInput"
					ref="tzEditor"
					:ossData="ossData"
					:ossObj="ossObj"
					/> -->
					<myEditor ref="tzEditor" @handleTinymceInput="handleTinymceInput" :ossData="ossData" :ossObj="ossObj"/>
					</el-form-item>
					<el-form-item prop="openapi_id">
						<template slot="label">
							<div class="bill-info-title">开放平台配置</div>
						</template>
						<el-select v-model="examineRuleForm.openapi_id" @change="openapiChange" filterable
							placeholder="请选择开放平台配置">
							<el-option v-for="item in openapiList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
		</ModalDialog>
    <!-- 查看原因 -->
    <div>
      <ModalDialog
        @dialogConfirm="reasonDialogClose"
        @dialogClose="reasonDialogClose"
        :dialogData="dialogData"
        :showButton="['', 'determine']"
      >
        <template slot="content">
          <div v-if="dialogData.visible" class="reasonBox">
            <!-- <div v-html="this.reasonData.content"></div> -->
			<myEditor :editorHeight="500" :initHtml="this.reasonData.content"/>
          </div>
        </template>
      </ModalDialog>
    </div>
	</div>
</template>

<script>
    import ApeEditor from "@/components/ApeEditor/ApeEditor.vue";
	import myEditor from "@/components/ApeEditor/myEditor.vue";
	import PageHeaderLayout from '@/layouts/PageHeaderLayout'
	import TreeTable from '@/components/TreeTable'
	import ModalDialog from '@/components/ModalDialog'
	import MonthPicker from '@/components/MonthPicker.vue'
	import {
		mapGetters
	} from 'vuex'

	export default {
		components: {
			PageHeaderLayout,
			TreeTable,
			ModalDialog,
			MonthPicker,
			ApeEditor,
			myEditor
		},
		watch: {
			"$route.matched": function(n) {
				if (n.length === 2) {
					this.init();
				}
			},
			"examineRuleForm.status": function(val) {
				if (val) {
					this.examineDialogData.loading = false
				} else {
					this.examineDialogData.loading = true
				}
			}
		},
		data() {
			return {
        formData: {
          details: "",
        },
        dialogData: {
          visible: false,
          width: "40%",
        },
        reasonData: {
          details: "",
        },
        ossObj: {},
        ossData: {},
				exportOptions: [{
					value: 'xlsx',
					label: 'xlsx'
				}, {
					value: 'csv',
					label: 'csv'
				}, {
					value: 'txt',
					label: 'txt'
				}],
				exportType: 'xlsx',
				exportSearch: {
					start_time: '',
					end_time: ''
				},
				downloadLoading: false,
				openapiList: [],
				examineDialogData: { //审核模态框
					visible: false,
					title: '',
					width: '40%',
					loading: true,
					modal: false
				},
				examineRuleForm: { //审核数据
					id: '',
					status: '',
					check_remark: ''
				},
				options: [{ //筛选状态
					value: '1',
					label: '通过'
				}, {
					value: '2',
					label: '拒绝'
				}, {
					value: '0',
					label: '审核中'
				}, {
					value: '3',
					label: '禁用'
				}],
				loadingStaus: true,
				searchCondition: {
					status: '',
					create_uid: '',
				},
					createNameList:[],
				columns: [{
						title: '公司名称',
						operation: true, // 作为展开操作列
						value: 'name',
						header_align: 'left',
						align: 'left',
						width: 260
					},
					{
						title: '公司账号',
						header_align: 'center',
						align: 'center',
						value: 'account'
					},
					{
						title: '开户行',
						header_align: 'center',
						align: 'center',
						value: 'bank',
						width: 300
					},
					{
						title: '企业电话',
						header_align: 'center',
						align: 'center',
						value: 'company_phone'
					},
					{
						title: '创建人',
						header_align: 'center',
						align: 'center',
						value: 'created_name'
					},
					{
						title: '创建时间',
						header_align: 'center',
						align: 'center',
						width: 200,
						value: 'created_at'
					},
				],
				list: [], // 表格列表数据
				pagingData: { // 分页信息
					is_show: true,
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0
				},
				offset: 0, // 分页的offset,序号列使用
			}
		},
		computed: {
			...mapGetters(['userPermissions'])
		},
		methods: {
      // 查看驳回原因
      showReason(row) {
        this.reasonData.content = row.review_remark;
        this.dialogData.visible = true;
      },
      // 关闭驳回窗口
      reasonDialogClose() {
        this.dialogData.visible = false;
      },
      // 获取oss认证
      async ossUpload() {
        const res_oss = await this.$api.getOssSign({
          dir: "xladmin/bill",
        });
        if (res_oss) {
          this.ossObj = res_oss;
          this.ossData = {
            ossAccessKeyId: res_oss.accessid,
            policy: res_oss.policy,
            signature: res_oss.signature,
          };
        } else {
          this.$message.error("获取oss签名失败");
        }
      },
      // 处理编辑器内容输入
      handleTinymceInput(val) {
        // console.log(val);
        this.formData.details = val;
      },
			// 搜索
			handleSelect(value) {
				this.searchCondition.create_uid = value?.create_uid
			},
			//导出
			async handleDownload() {
				console.log(this.exportSearch);
				let list = []
				let searchCondition = this.handleSearchCondition()
				if(this.exportSearch.start_time === '' && this.exportSearch.end_time === '') {
				let {
					data
				} = await this.$api.companyInterface({
					current_page: 1,
					page_size: 50000,
					...searchCondition,
					channel_accounts:localStorage.getItem('home_channel_account')||''
				})
				list = data
				} else {
					let {
					data
				} = await this.$api.companyInterface({
					current_page: 1,
					page_size: 50000,
					...searchCondition,
					...this.exportSearch,
					channel_accounts:localStorage.getItem('home_channel_account')||''
				})
				list = data
				}
				this.downloadLoading = true
				import('@/excel/Export2Excel').then(excel => {
					const tHeader = ['ID', '公司名称', '公司账号', '开户行', '企业电话', '创建人', '驳回原因', '状态', '创建时间'];
					const data = this.formatJson(list)
					const time = new Date().getTime() + Math.random() * 1000
					let filename = `API商户${time}`
					excel.export_json_to_excel({
						header: tHeader, //Header Required
						data, //Specific data Required
						filename: filename, //Optional
						autoWidth: true, //Optional
						bookType: this.exportType, //Optional
					})
					this.downloadLoading = false;
				})
			},
			//转换导出数据
			formatJson(jsonData) {
				return jsonData.map(v => {
					let {
						id,
						name,
						account,
						bank,
						company_phone,
						created_name,
						review_remark,
						alias_status,
						created_at
					} = v
					return [id, name, account, bank, company_phone, created_name,
						review_remark, alias_status, created_at
					]
				})
			},
			// 导出日期
			MonthSearch(v) {

				if (v) {
					this.exportSearch.start_time = v[0]
					this.exportSearch.end_time = v[1]
				}
			},
			//获取开放平台配置列表
			async getOpenapiList(id) {
				let result = await this.$api.getOpenapiCategoryList(id)
				if (result) {
					this.openapiList = result
				}
			},
			//开放平台配置
			openapiChange(v) {
				if (v) {
					this.examineRuleForm.openapi_id = v
				}
			},
			//审核
			async companyAudit() {
				let args = {
					status: this.examineRuleForm.status,
					openapi_id: this.examineRuleForm.openapi_id
				}
				if (this.examineRuleForm.status == 1) {
					if (this.examineRuleForm.openapi_id) {
						let result = await this.$api.companyAudit(this.examineRuleForm.id, args)
						if (result) {
							// 调用组件的数据验证方法
							this.examineRuleForm = {}
							this.examineDialogData.visible = false
							this.init()
						}
					} else {
						this.$message.info('请选择开放平台配置')
					}
				} else {
					this.examineRuleForm.check_remark = this.formData.details
					let result = await this.$api.companyAudit(this.examineRuleForm.id, {...args,review_remark:this.examineRuleForm.check_remark})
					if (result) {
						// 调用组件的数据验证方法
						this.examineRuleForm = {}
						this.examineDialogData.visible = false
						this.init()
					}
				}
			},
			// 处理审核模态框，确定事件
			examineHandleConfirm() {
				this.companyAudit()
			},
			examineDialogClose() {
				this.examineRuleForm = {}
				this.examineDialogData.visible = false
			},
			selectRadio() {
				if (this.examineRuleForm.status == 2) {
					this.examineRuleForm.check_remark = ''
				}
			},
			// 切换页码操作
			async switchPaging() {
				this.init()
			},
			//塞选状态
			selectClick(event) {
				this.searchCondition.status = event
			},
			//创建公司
			createCompany() {
				this.$router.push({
					path: this.$route.path + "/create",
					query: {
						category: 'member'
					}
				})
			},
			//审核
			toExamine(id) {
				console.log("审核")
				this.examineDialogData.title = `审核${id}`
				this.examineDialogData.visible = true
				this.examineRuleForm.id = id
				this.getOpenapiList()
			},
			//查询
			searchButton() {
				this.searchCondition.current_page = 1
				this.init('toFirst')
			},
			// 处理搜索条件
			handleSearchCondition() {
				let condition = {}
				if (this.searchCondition.name) {
					condition.name = this.searchCondition.name
				}
				if (this.searchCondition.status) {
					condition.status = this.searchCondition.status
				}
				if (this.searchCondition.created_name) {
					condition.created_name = this.searchCondition.created_name
				}
				if (this.searchCondition.create_uid) {
					condition.create_uid = this.searchCondition.create_uid
				}
				if (this.searchCondition.create_name) {
					condition.create_name = this.searchCondition.create_name
				}
				return condition
			},
			// 响应添加按钮
			async addButton(id) {
				this.$router.push({
					path: this.$route.path + "/" + id + "/create",
					query: {
						category: 'member',
						id: id,
						son: 'son'
					}
				})
			},
			async getCreateNameListInfo(){
				const  res=	await this.$api.getCreateNameList()
				res.forEach(item=>{
					this.createNameList.push({
						value:item.create_uid,
						label:item.fullname
					})
				})
				},
			// 响应编辑按钮
			async editButton(id) {
				this.$router.push({
					path: this.$route.path + "/" + id + "/edit",
					query: {
						category: 'member',
						id: id
					}
				})
			},
			// 删除商户
			async deleteButton(id) {
				let result = await this.$api.deleteCompany(id)
				if (result) {
					this.$message.success('删除成功')
					this.init()
				}
			},
			// 初始化公司列表
			async init(type) {
				let pagingInfo = this.$refs['treeTable'].getPagingInfo(type)
				this.loadingStaus = true
				let searchCondition = this.handleSearchCondition()
				// if(Object.keys(searchCondition).length !== 0) {
				// 	Object.assign(searchCondition,{current_page:1,page_size:this.pagingData.total})
				// } else {
				// 	Object.assign(searchCondition, pagingInfo)
				// }
				Object.assign(searchCondition, pagingInfo)
				
				console.log(searchCondition,'查询条件')

				let {
					data,
					pages
				} = await this.$api.companyInterface({...searchCondition,channel_accounts:localStorage.getItem('home_channel_account')||''})
				this.$nextTick(() => {
					this.list = data
				})
				this.pagingData.total = pages.total
				this.offset = pages.offset
				this.loadingStaus = false
			},
		},
		async mounted() {
			this.init()
			this.getCreateNameListInfo()
      this.ossUpload();
		},
	}
</script>

<style lang="scss" scoped>
	.reasonBox {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	/deep/ .el-row {
		margin-bottom: 0;
	}

	.add-color {
		color: #f56c6c
	}

	.el-button {
		margin-right: 4px;
		margin-bottom: 4px;
	}

	.table-header {
		// margin-bottom: 12px;
		display: flex;
		justify-content: space-between;

	}

	.table-heade-left {
		display: flex;
	}

	.create-btn {
		height: 36px;
	}

	.drag-handle {
		font-size: 24px;
		cursor: pointer;
	}

	.select-wrapper {
		width: 150px
	}
</style>
